/**
 * How to reach E-Swift itself.
 *
 * Distinct from `instituteBranding`, which carries the phone and email of
 * whichever INSTITUTE is signed in — that is what belongs on their receipts and
 * their printouts. This is the number for the platform behind them, for the
 * cases where an institute (or someone who cannot even sign in) needs the
 * people who run it.
 *
 * One constant, so the number is changed in one place rather than being
 * discovered later in three.
 */
export const PLATFORM_PHONE = '+91 84465 96198';

/** `tel:` wants no spaces. */
export const PLATFORM_PHONE_HREF = `tel:${PLATFORM_PHONE.replace(/\s+/g, '')}`;
